"use client";

import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { motion } from "framer-motion";
import { PhosphorIcon } from "@/components/marketing/PhosphorIcon";
import type { IBenefitItem } from "@/lib/sanity/types";
import { marketingMotion } from "@/lib/motion/config";

interface IBenefitsGridProps {
  benefits: IBenefitItem[];
  /** Number of columns on md+ (default 2). */
  columns?: 2 | 3 | 4;
}

const gridCols: Record<number, string> = {
  2: "sm:grid-cols-2",
  3: "sm:grid-cols-2 lg:grid-cols-3",
  4: "sm:grid-cols-2 lg:grid-cols-4",
};

export function BenefitsGrid({
  benefits,
  columns = 2,
}: IBenefitsGridProps): React.ReactElement {
  return (
    <div className={`grid gap-6 ${gridCols[columns]}`}>
      {benefits.map((item) => (
        <motion.div
          key={item._key}
          initial={{ opacity: 0, y: 12, scale: 0.98 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={marketingMotion.viewport}
          transition={{ duration: marketingMotion.duration.base }}
          whileHover={{ y: -4 }}
        >
        <Card className="transition-shadow duration-200 hover:shadow-md">
          <CardHeader>
            {item.icon && (
              <PhosphorIcon
                name={item.icon}
                className="mb-2 h-8 w-8 text-primary"
              />
            )}
            <CardTitle className="text-lg">{item.title}</CardTitle>
            <CardDescription>{item.description}</CardDescription>
          </CardHeader>
        </Card>
        </motion.div>
      ))}
    </div>
  );
}
